module.exports = "<i class=\"padding-right\" ng-class=\"{\n    'state-okay ion-arrow-up-a' : $ctrl.storageState == 'OKAY',\n    'state-marginal ion-arrow-right-a' : $ctrl.storageState == 'MARGINAL',\n    'state-risky ion-arrow-down-a' : $ctrl.storageState == 'RISKY'}\">\n</i>\n\n<span ng-if=\"::$ctrl.withLabel\" translate>\n    {{$ctrl.storageState}}\n</span>\n";


//////////////////
// WEBPACK FOOTER
// ./src/modules/main/components/wheel-storage-state-icon/wheel-storage-state-icon.html
// module id = 894
// module chunks = 0